const announcementQueryKeys = {
  all: ['announcements'] as const,
  lists: () => ['announcements', 'list'] as const,
  list: (agencyId: string, page?: number) => ['announcements', 'list', agencyId, page] as const,
  detail: (announcementId: string) => ['announcements', 'detail', announcementId] as const,
  pending: () => ['announcements', 'pending'] as const,
};

export default announcementQueryKeys;
